import { gql } from '@apollo/client';

// ✅ Not needed anymore — local backend's getUser has all the data
// Keeping this as a no-op so we don't have to refactor AppBar heavily
export const GET_IAM_USER_DETAILS = null;

export const FETCH_USER = gql`
  query IAMfetchUser($input: FetchUserInput) {
    IAMfetchUser(input: $input) {
      status
      message
      user {
        userId
        email
        firstName
        lastName
        mobileNumber
        organizationId
        product
        role
        status
        isProfileCompleted
        registrationStatus
      }
    }
  }
`;